module.exports = __webpack_public_path__ + "static/img/brees-2019-slide-5.c364544.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2019-slide-5.jpg
// module id = 7ufR
// module chunks = 1